import * as SurveyResponseController from "../../../store/StateControllers/Survey/SurveyResponse/SurveyResponseController";
import { IStringLocalizer } from "../../../utilities/IStringLocalizer";
import { SurveyDataRequested, DataCollectionAiAgentOperationType } from "../../../store/Models/Surveys/SurveyDataModel";
import { ToxnotReactModal, ToxnotReactModalBody, ToxnotReactModalFooter } from "../ToxnotReactModal";
import { ChangeEvent, useState } from "react";
import { ProgressBar } from "../ProgressBar";
import { ToxnotServiceClient } from "../../../store/ToxnotServiceClient";
import { ProcessingStage } from "../../../store/Models/SharedMaterials/DataModel";
import { OfflineProcessStageManager } from "../../../utilities/OfflineProcessStage";
import SupplierAiAgent from "../SupplierAiAgent/SupplierAiAgent";
import './style.css';
interface Props {
    localizer: IStringLocalizer;
    responseId: string;
    requestId?: string;
    materialIdsDataToLoadList?: string[];
    requestedData?: SurveyDataRequested;
    bomQuestionnaireId?: string;
    needsMaterialBomResponse: boolean;
    onNextPage?: () => void;
}

const BatchButtons: React.FC<Props> = ({ localizer, responseId, requestId, materialIdsDataToLoadList, requestedData, bomQuestionnaireId, needsMaterialBomResponse, onNextPage }) => {
    const [formVisibility, setFormVisibility] = useState(true);
    const [uploadVisibility, setUploadVisibility] = useState(false);
    const [importVisibility, setImportVisibility] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [doneVisibility, setDoneVisibility] = useState(false);
    const [wasSuccessful, setWasSuccessful] = useState(false);
    const [warningVisiblity, setWarningVisiblity] = useState(false);
    const [totalNumItems, setTotalNumItems] = useState(0);
    const [currentProgress, setCurrentProgress] = useState(0);
    const [importStatusMessage, setImportStatusMessage] = useState(OfflineProcessStageManager.processingStageMessages.first(s => s.processingStage == ProcessingStage.Queued).friendlyMessage);
    const modalId = "bulk-import-boms-modal";
    const ok = "Ok";
    const trueAsString = "true";

    const serviceClient = new ToxnotServiceClient();
    let file: File | null;

    const createRedirectButton = (buttonText: string, redirectUrl: string, iconClass: string, helperText: string) => {
        return <button className="btn btn-default m-r-5 batch-buttons-import-button" onClick={() => window.open(redirectUrl, "_blank")}>
            <i className={iconClass}></i>
            <div className="batch-buttons-button-content">
                <span className="batch-buttons-button-title">{buttonText}</span>
                <span className="batch-buttons-button-helper">{localizer.localizeString(helperText)}</span>
            </div>
        </button>
    }

    const isAskingForAnySummaryData = () => {
        let dataRequested = requestedData ?? null;
        if (dataRequested !== null)
            if (dataRequested.circularityDataAsked ||
                dataRequested.complianceList.length > 0 ||
                dataRequested.sustainabilityDataAsked ||
                dataRequested.documentsCertificationList.length)
                return true;
        return false;
    }

    const onFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files?.length > 0) {
            file = e.target.files[0];
        } else {
            file = null;
        }
    }

    const onSubmit = () => {
        if (file === null || file === undefined) {
            setWarningVisiblity(true);
        } else {
            setWarningVisiblity(false);
            setFormVisibility(false);
            setUploadVisibility(true);
            serviceClient.batchSurveyResponseBomImport(responseId, file).then((result) => {
                setUploadVisibility(false);

                if (result?.result == ok) {
                    setUploadProgress(1);
                    setImportVisibility(true);
                    serviceClient.enqueueImport(result.importId).then(() => {
                        var getDataInterval = setInterval(() => { getImportData(result.importId, getDataInterval) }, 1500);
                    })
                }
            })
        }
    }

    const getImportData = (importId: string, getDataInterval: any) => {
        serviceClient.importDataGet(importId, trueAsString).then((result) => {
            console.log(result)
            setTotalNumItems(result?.import.state.progressTotalNumItems ?? 0);
            setCurrentProgress(result?.import.state.currentProgressItemIndex ?? 0);
            setImportStatusMessage(OfflineProcessStageManager.processingStageMessages.firstOrDefault(s => s.processingStage == result?.import.state.processingStage)?.friendlyMessage ?? "");

            if (result?.import.state.processingStage == ProcessingStage.TotallyComplete) {
                setWasSuccessful(true);
                clearInterval(getDataInterval)
                setDoneVisibility(true);
                setImportVisibility(false);
            } else if (result?.import.state.processingStage == ProcessingStage.Failed) {
                setWasSuccessful(false);
                clearInterval(getDataInterval)
                setDoneVisibility(true);
                setImportVisibility(false);
            }
        });
    }

    $("#" + modalId).off("hidden.bs.modal").on("hidden.bs.modal", () => {
        setUploadProgress(0);
        setCurrentProgress(0);
        setTotalNumItems(0);
        setDoneVisibility(false);
        setFormVisibility(true);
        setUploadVisibility(false);
        setImportVisibility(false);
        setWarningVisiblity(false);
        setImportStatusMessage(OfflineProcessStageManager.processingStageMessages.first(s => s.processingStage == ProcessingStage.Queued).friendlyMessage);
    })

    const bulkImportSds = needsMaterialBomResponse && (materialIdsDataToLoadList && materialIdsDataToLoadList?.length >= SurveyResponseController.materiaListSizeGroupThreshold)
        ? createRedirectButton(localizer.localizeString("Bulk Import SDS Files"), encodeURI(`/Data/NewProduct?responseId=${responseId}&mode=MSDS Library`), "glyphicon glyphicon-file", "Upload safety data sheets")
        : null;

    const batchAnswerQuestionnaire = createRedirectButton(localizer.localizeString("Batch Answer Questionnaire"),
        encodeURI((isAskingForAnySummaryData()) ?
            `/Surveys/AnswerQuestionnaire?responseId=${responseId}&mode=batch&questionnaireType=InventorySummaryData&return=true`
            : `/Surveys/AnswerQuestionnaire?responseId=${responseId}&mode=batch&questionnaireType=Default&return=true`), "glyphicon glyphicon-list-alt", "Answer multiple questions")

    const bulkImportSpreadsheet = needsMaterialBomResponse && <button className="btn btn-default m-r-5 batch-buttons-import-button" data-toggle="modal" data-target="#bulk-import-boms-modal">
        <i className="glyphicon glyphicon-list-alt"></i>
        <div className="batch-buttons-button-content">
            <span className="batch-buttons-button-title">{localizer.localizeString("Bulk Import Spreadsheet")}</span>
            <span className="batch-buttons-button-helper">{localizer.localizeString("Import from Excel/CSV")}</span>
        </div>
    </button>;

    return (
        <>
            {/* AI Document Processing Section */}
            <div className="m-b-25">
                <SupplierAiAgent
                    localizer={localizer}
                    requestId={requestId}
                    operationType={DataCollectionAiAgentOperationType.Survey}
                    onNextPage={onNextPage}
                />
            </div>

            {/* Bulk Inputs Section - AI Card Style */}
            <div className="batch-buttons-bulk-inputs-card-container">
                <div className="batch-buttons-bulk-inputs-card">
                    <div className="batch-buttons-bulk-inputs-header">
                        <h3 className="batch-buttons-bulk-inputs-title">{localizer.localizeString("Bulk Inputs")}
                            <span className="badge m-l-5">{localizer.localizeString("Optional")}</span>
                        </h3>
                        <p className="batch-buttons-bulk-inputs-description">
                            {localizer.localizeString("To start the process you can bulk import the substances for your products and 3E Exchange will help to screen for regulated substances to respond to customer surveys.")}
                            <b><i>{localizer.localizeString("Import substances via spreadsheet or Safety Data Sheet below")}</i></b>
                        </p>
                        
                        <div className="batch-buttons-bulk-import-container">
                            {bulkImportSds}
                            {bulkImportSpreadsheet}
                            {batchAnswerQuestionnaire}
                        </div>
                    </div>
                </div>
            </div>
            <ToxnotReactModal modalId={modalId} localizedTitle={localizer.localizeString("Bulk Import Material Content")}>
                <ToxnotReactModalBody>
                    {formVisibility &&
                        <div className="upload-form">
                            <p>
                                {localizer.localizeString("You can import data from a Spreadsheet File (Excel XLSX, or CSV).")}
                            </p>
                            <p>
                                <a href={`/Api/ImportTemplateForResponse?responseId=${responseId}&generateBatchImportTemplate=True&exportOnlyInventoriesWithRevisionRequests=True`}>{localizer.localizeString("Click here to download a bulk import template for many materials.")}</a>
                            </p>
                            <div className="alert alert-warning">
                                {localizer.localizeString("Warning: When you import data from a file, you'll overwrite all existing material data in the editor.")}
                            </div>
                            <div className="form-group">
                                <input type="file" id="bulk-import-boms-file-input" className="form-control" accept=".csv,.txt,.tsv,.xlsx,.xlsm" onChange={(e) => onFileChange(e)} />
                            </div>
                        </div>
                    }
                    {uploadVisibility &&
                        <div className="spreadsheet-upload-progress-form">
                            <div id="file-upload-status-container">
                                <ProgressBar localizedTitle={localizer.localizeString("Uploading File")} totalNumItems={1} currentProgressIndex={uploadProgress} localizer={localizer}></ProgressBar>
                            </div>
                        </div>
                    }
                    {importVisibility &&
                        <div className="offline-import-status-form">
                            <div id="offline-import-status-container">
                                <div className="alert alert-info">
                                    <p>{localizer.localizeString("3E Exchange is importing your data. This might take a while.")}</p>
                                    <p>{localizer.localizeString("We'll email you when it's done, or you can come back later and check your status on the Imports page.")}</p>
                                    <p>{localizer.localizeString("You can safely leave this page.")}</p>
                                </div>
                                <ProgressBar localizedTitle={localizer.localizeString(importStatusMessage)} totalNumItems={totalNumItems} currentProgressIndex={currentProgress} localizer={localizer}></ProgressBar>
                            </div>
                        </div>
                    }
                    {doneVisibility &&
                        <div className="done-form">
                            {wasSuccessful == true ?
                                <div className="alert alert-success">
                                    {localizer.localizeString("Your import was successful.")}
                                </div> :
                                <div className="alert alert-danger">
                                    {localizer.localizeString("Sorry, there was a problem accessing the service. Please try again.")}
                                </div>}
                        </div>
                    }
                    {warningVisiblity &&
                        <div className="alert alert-danger">
                            <p>
                                {localizer.localizeString("Please select a file for upload.")}
                            </p>
                        </div>
                    }
                </ToxnotReactModalBody>
                <ToxnotReactModalFooter localizer={localizer} enabledCloseButton={formVisibility}>
                    {formVisibility && <button type="button" id="bulk-import-boms-submit-button" className="btn btn-toxnot-primary" onClick={() => onSubmit()}>{localizer.localizeString("Import File")} </button>}
                    {doneVisibility && <button type="button" data-dismiss="modal" id="bulk-import-boms-done-button" className="btn btn-toxnot-primary" onClick={() => wasSuccessful ? null : window.location.reload()}>{localizer.localizeString("Ok")}</button>}
                </ToxnotReactModalFooter>
            </ToxnotReactModal>
        </>
    )
}

export default BatchButtons;
